import ApiGet from "../../../../api-controller-mod/api-serv/get-api/getApi";
import { BadgeVariant } from "../../../../component-controller-mod/component-serv/badge-fs-cp/dynamic-badge-op/ts/statusBadgeWorkflow";
import { WorkflowCardProps } from "../../../../component-controller-mod/component-serv/dashboard-fs-cp/workflow-dsb-op/workflow-card/ts/workflowCard";
import { API_ENDPOINTS } from "../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider";
import chartIcon       from '../../../../asset-controller-mod/asset-serv/images/chart.png';
import rocketIcon      from '../../../../asset-controller-mod/asset-serv/images/rocket.png';
import infoIcon        from '../../../../asset-controller-mod/asset-serv/images/info.png';
import calendarIcon    from '../../../../asset-controller-mod/asset-serv/images/calendar.png';
import closeCircleIcon from '../../../../asset-controller-mod/asset-serv/images/close-circle.png';
import apiGetFromAuth from "../../../../api-controller-mod/api-serv/get-api/getApiFromAuth";
import ApiPut from "../../../../api-controller-mod/api-serv/put-api/putApi";

/** Filters */
export const status = [
  { value: "all", label: "All" },
  { value: "DRAFT", label: "Draft" },
  { value: "REVIEWED", label: "In Review" },
  { value: "SCHEDULED", label: "Scheduled" },
  { value: "PUBLISHED", label: "Published" },
  { value: "REJECTED", label: "Rejected" },
];

export const TypeBussiness = [
  { value: "all", label: "All" },
  { value: "footer", label: "Footer" },
  { value: "header", label: "Header" },
  { value: "company", label: "Company" },
  { value: "career", label: "Career" },
  { value: "product", label: "Product" },
  { value: "contact", label: "Contact" },
  { value: "businessContact", label: "Business Contact" },
  { value: "saleContact", label: "Sale Contact" },
  { value: "jobDetail", label: "Job Detail" },
  { value: "testing", label: "Testing" },
];

/** Table */
export const columns = ["ID", "Page", "Title", "Version", "Create date", "Author", "Status", "Action"];

/** API Types */
export type ContentVersionItem = {
  contentId: number;
  contentVersionUuid: string;
  contentUuid: string;
  version: number;
  data?: Record<string, unknown>;
  summary?: string | null;
  createdBy?: string;
  isPublished?: boolean;
  status?: string;
  createdAt?: string;
};

export type ContentVersionIndexResponse = {
  data?: ContentVersionItem[];
};

export type WorkflowRow = {
  id: string;
  ID: string;
  Page: string;
  Title: string;
  Version: string;
  "Create date": string;
  Author: string;
  Status: string;
  _raw?: ContentVersionItem;
  Action?: React.ReactNode;
};

/** API */
export const getContentVersionIndexApi = () =>
  ApiGet<ContentVersionIndexResponse>(API_ENDPOINTS.GET_CONTENT_VERSION_INDEX);

export const toBadgeVariant = (value?: string): BadgeVariant => {
  switch (value?.toLowerCase()) {
    case "published":
      return "published";
    case "unpublished":
    case "unpublish":
      return "unpublished";
    case "draft":
      return "draft";
    case "new":
      return "new";
    case "reviewed":
      return "reviewed";
    case "shortlisted":
    case "scheduled":
      return "scheduled";
    case "interviewed":
      return "interviewed";
    case "rejected":
      return "rejected";
    case "hired":
      return "hired";
    default:
      return "draft";
  }
};

export const normalizeSearch = (s: string) =>
  s.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();

export const STATUS_OPTIONS = [
  { value: "DRAFT", label: "Draft" },
  { value: "REVIEWED", label: "Reviewed" },
  { value: "SCHEDULED", label: "Scheduled" },
  { value: "REJECTED", label: "Rejected" },
  { value: "PUBLISHED", label: "Published" },
  { value: "UNPUBLISHED", label: "Unpublished" },
];

export const HeaderData = [
  {
    type: "toggle",
    title: "Navigation item",
  },
  {
    type: "preview",
    title: "Product"
  },
  {
    type: "preview",
    title: "Career"
  },
  {
    type: "preview",
    title: "Company"
  },
  {
    type: "image",
    title: "Company logo"
  },
  {
    type: "button",
    title: "Primary button"
  },
];

export type PreviewItem = {
  type: "toggle" | "preview" | "description" | "image" | "imageButton" | "button";
};

export const previewData: PreviewItem[] = [
  { type: "toggle" },
  { type: "preview" },
  { type: "toggle" },
  { type: "description" },
  { type: "toggle" },
  { type: "image" },
  { type: "toggle" },
  { type: "imageButton" },
];

export type WorkflowStatCard = WorkflowCardProps & {
  id: string
}

export const WORKFLOW_CARDS: WorkflowStatCard[] = [
  {
    id: "draft",
    label: "Draft",
    value: 0,
    color: "#8A8B8F",
    gradient: "linear-gradient(88.49deg, #C8C8C8 0%, #DCDDDD 100%)",
    borderColor: "#C8C8C8",
    iconSrc: infoIcon,
    iconAlt: "Draft icon",
    backgroundColor: "rgba(237, 238, 239, 0.5)"
  },
  {
    id: "inReview",
    label: "In Review",
    value: 0,
    color: "#4A95ED",
    gradient: "linear-gradient(88.49deg, #4A95ED 0%, #97CCF3 100%)",
    borderColor: "#4A95ED",
    iconSrc: chartIcon,
    iconAlt: "Review icon",
    backgroundColor: "rgba(227, 239, 255, 0.5)"
  },
  {
    id: "schedule",
    label: "Schedule",
    value: 0,
    color: "#FF9416",
    gradient: "linear-gradient(89.62deg, #FF9416 0%, #F5B76F 100%)",
    borderColor: "#FF9416",
    iconSrc: calendarIcon,
    iconAlt: "Schedule icon",
    backgroundColor: "rgba(255, 148, 22, 0.1)"
  },
  {
    id: "published",
    label: "Published",
    value: 0,
    color: "#8A38F5",
    gradient: "linear-gradient(89.62deg, #8A38F5 0%, #BB8AFA 100%)",
    borderColor: "#8A38F5",
    iconSrc: rocketIcon,
    iconAlt: "Published icon",
    backgroundColor: "rgba(249, 244, 255, 1)"
  },
  {
    id: "reject",
    label: "Rejected",
    value: 0,
    color: "#FF2D46",
    gradient: "linear-gradient(88.58deg, #FF475D 0.13%, #FF888F 100%)",
    borderColor: "#FF475D",
    iconSrc: closeCircleIcon,
    iconAlt: "Rejected icon",
    backgroundColor: "rgba(255, 236, 239, 1)"
  }
]

export type ApiResponse<T> = {
  success: boolean;
  requestId: string;
  data: T;
};

export type ContentVersionBase = {
  contentId: number;
  contentUuid: string;
  contentVersionUuid: string;
  version: number;
  isPublished: boolean;
  status: string;
  summary?: string | null;
  createdBy?: string;
  createdAt?: string;
  publishAt?: string | null;
  data?: Record<string, any>;
};

export type OverviewWorkflow = {
  total: number;
  published: number;
  unpublish: number;
  draft: number;
  schedule: number;
  reject: number;
};

export type OverviewResponse = {
  jobPost: {
    total: number;
    opening: number;
    active: number;
    closed: number;
    reviewed: number;
    submission: number;
  };
  inbox: {
    total: number;
    bussiness: number;
    sale: number;
  };
  media: {
    total: number;
    image: number;
    video: number;
    active: number;
    inused: number;
    unused: number;
  };
  workflow: OverviewWorkflow;
};

export const getDataOverview = () =>
  ApiGet<ApiResponse<OverviewResponse>>(API_ENDPOINTS.GET_OVERVIEW);

export type WorkflowSubmitPayload = {
  contentVersionUuid: string;
  approverUuid: string;
  requesterUuid: string;
  contentUuid: string;
  notifyUuid: string;
  userUuid: string;
  status: string;
  publishAt: string | null;
};

export type ContentUpdatePath = Array<string | number>;

export type ContentUpdateItem = {
  path: ContentUpdatePath;
  value: string;
};

export type ContentUpdatePayload = {
  type: string;
  title: string;
  version: number;
  updates: ContentUpdateItem[];
};

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};

export const collectStatusUpdatePaths = (
  value: unknown,
  currentPath: Array<string | number> = []
): Array<Array<string | number>> => {
  const paths: Array<Array<string | number>> = [];

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      paths.push(...collectStatusUpdatePaths(item, [...currentPath, index]));
    });
    return paths;
  }

  if (!isPlainObject(value)) {
    return paths;
  }

  if (Object.prototype.hasOwnProperty.call(value, "status")) {
    paths.push([...currentPath, "status"]);
  }

  Object.entries(value).forEach(([key, child]) => {
    paths.push(...collectStatusUpdatePaths(child, [...currentPath, key]));
  });

  return paths;
};

export const updateContentVersionApi = (
  contentUuid: string,
  versionUuid: string,
  userId: string,
  payload: ContentUpdatePayload
) =>
  ApiPut<ApiResponse<unknown>>(
    `${API_ENDPOINTS.API_CONTENT_UPDATE}?contentUuid=${encodeURIComponent(contentUuid)}&versionUuid=${encodeURIComponent(versionUuid)}&userId=${encodeURIComponent(userId)}`,
    payload
  );

export const getDetailUuid = (uuid: string) =>
  apiGetFromAuth(API_ENDPOINTS.GET_USER_BY_UUID(uuid));

export const getSectionByUUID = (versionId: string) =>
  ApiGet<ApiResponse<ContentVersionBase>>(
    `${API_ENDPOINTS.GET_CONTENT_SECTION_BY_UUID}?version=${versionId}`
  );

